import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkifyPipe } from './linkify.pipe';
import { SanitizePipe } from './sanitize.pipe';
import { EscapeHtmlPipe } from './escape-html.pipe';
import { RoleBackgroundPipe } from './roleBackground.pipe';
import { TwemojiPipe } from './twemoji';

@NgModule({
  declarations: [LinkifyPipe, SanitizePipe, EscapeHtmlPipe, RoleBackgroundPipe, TwemojiPipe],
  imports: [CommonModule],
  exports: [LinkifyPipe, SanitizePipe, EscapeHtmlPipe, RoleBackgroundPipe, TwemojiPipe]
})
export class PipesModule { }
